import Layout from '@/views/layout'
import store from '../../store'

// const isSdLogin = JSON.parse(sessionStorage.getItem('isSdLogin'))
const platformName = store.getters.platformName

export default [
  {
    path: '/tuan',
    name: 'tuan',
    redirect: '/tuan/tuanOptimization',
    component: Layout,
    meta: {
      title: `${platformName}优选`,
      icon: 'workPlant.png',
      index: 20
    },
    children: [
      {
        path: 'tuanOptimization',
        name: 'tuanOptimization',
        meta: {
          title: `${platformName}优选`,
        },
        component: () => import('@/views/tuanOptimization/index')
      }
    ]
  }
]